export const pt = {
    title: `Alterar senha`,
    description: `Atualize a senha da sua conta`,
    passwordChanged: `Senha alterada com sucesso!`,
    changePasswordButton: `Alterar senha`,
    changingPassword: `Alterando senha...`,
    sessionExpired: `Sua sessão expirou. Por favor entre novamente.`,
    failure: `Falha ao alterar a senha`,
};
//# sourceMappingURL=pt.js.map